import { Language } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { SearchParamsState } from '@store';

interface UseUrlSearchParamsOutput {
	searchParams: SearchParamsState;
	clearSearchParams: () => void;
}

export const useURLSearchParams = (): UseUrlSearchParamsOutput => {
	const url = new URL(window.location.href);

	const responseType = url.searchParams.get('response_type') || '';
	const clientId = url.searchParams.get('client_id') || '';
	const redirectUri = url.searchParams.get('redirect_uri') || '';
	const codeChallenge = url.searchParams.get('code_challenge') || '';
	const codeChallengeMethod = url.searchParams.get('code_challenge_method') || '';
	const scope = url.searchParams.get('scope') || '';
	const state = url.searchParams.get('state') || '';
	const language = url.searchParams.get('language')?.toLowerCase();
	const epoch = url.searchParams.get('epoch') || '';
	const fallbackUri = url.searchParams.get('fallback_uri') || '';
	const k = url.searchParams.get('k') || url.searchParams.get('K') || '';
	const sf = url.searchParams.get('sf') || '';

	const clearSearchParams = () => {
		// Get the current URL and search parameters
		const currentUrl = new URL(window.location.href);

		// Remove all search parameters (query params)
		currentUrl.search = '';

		// Replace the current URL without refreshing the page
		window.history.replaceState({}, '', currentUrl.toString());
	};

	return {
		searchParams: {
			clientId,
			responseType,
			scope,
			redirectUri,
			codeChallenge,
			codeChallengeMethod,
			state,
			language: language === Language.en ? Language.en : Language.pt,
			epoch,
			fallbackUri,
			k,
			sf,
		},
		clearSearchParams,
	};
};
